/**
 *  城市api
 */
import { axios } from '@/utils/request'

const subPath = '/basicData/city'

export default {
  query,
  list,
  listByState,
  detail,
  add,
  update,
  'delete': remove
}

// 分页查询
function query (parameter) {
  return axios({
    url: `${subPath}/query`,
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}

// 通过国家ID查询列表
function list (countryId) {
  if (countryId && countryId !== '') {
    return axios({
      url: `${subPath}/list`,
      method: 'get',
      params: {countryId: countryId}
    })
  } else {
    return axios({
      url: `${subPath}/list`,
      method: 'get'
    })
  }
}

// 通过州ID查询城市列表
function listByState (stateId) {
  return axios({
    url: `${subPath}/listByState`,
    method: 'get',
    params: {stateId: stateId}
  })
}

// 详情
function detail (id) {
  return axios({
    url: `${subPath}/${id}`,
    method: 'get'
  })
}

// 添加
function add (parameter) {
  return axios({
    url: `${subPath}`,
    method: 'post',
    data: parameter
  })
}

// 修改
function update (id, parameter) {
  return axios({
    url: `${subPath}/${id}`,
    method: 'put',
    data: parameter
  })
}

// 删除
function remove (parameter) {
  return axios({
    url: `${subPath}`,
    method: 'delete',
    params: parameter
  })
}
